import Paper from "@material-ui/core/Paper"
import AppLanguageSwitch from "../components/LanguageSwitch"
import Stack from "./Stack"
import { Redirect, useLocation } from "react-router-dom"
import { useAppSelector } from "../store"
import { getAuthState } from "../users/store/selectors"
import { usePageTitle } from "../hooks/use-page-title"
import { useTheme } from "@material-ui/core"
import StarbrixLogo from "../assets/icons/StarbrixLogo"
import { DefaultAuthenticatedRedirect } from "./DefaultAuthenticatedRedirect"

export function withPublicRouteLayout(Component: React.ComponentType) {
  const WithLayout = () => {
    usePageTitle()
    const location = useLocation()
    const { isAuthenticated, user } = useAppSelector(getAuthState)
    const theme = useTheme()

    if (isAuthenticated) {
      const from = (location.state as { from?: Location })?.from || null
      if (from) return <Redirect to={from.pathname + from.search} />
      if (!user) return <Redirect to="/" />
      return <DefaultAuthenticatedRedirect user={user} />
    }

    return (
      <Paper
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
          background: "transparent",
        }}
        component={"main"}
      >
        <Paper
          variant="outlined"
          style={{
            maxWidth: 650,
            padding: 32,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: theme.spacing(4),
            }}
          >
            <StarbrixLogo />
          </div>

          <Stack>
            <AppLanguageSwitch />
            <Component />
          </Stack>
        </Paper>
      </Paper>
    )
  }
  return WithLayout
}
